export function detectDownloadPlatform(navigatorLike = {}) {
  const userAgent = String(navigatorLike.userAgent ?? "").toLowerCase();
  const declaredPlatform = String(navigatorLike.userAgentData?.platform ?? navigatorLike.platform ?? "").toLowerCase();
  const combined = `${declaredPlatform} ${userAgent}`;
  if (/android|iphone|ipad|ipod|mobile/.test(combined)) return "mobile";
  if (/windows|win32|win64/.test(combined)) return "windows";
  if (/macos|macintosh|macintel|mac os x/.test(combined)) return "macos";
  return "unknown";
}

export function visibleDownloadPlatforms(platform) {
  if (platform === "macos" || platform === "windows") return [platform];
  if (platform === "mobile") return [];
  return ["macos", "windows"];
}
